module.exports = __webpack_public_path__ + "static/media/icon.6b96cd30.png";